<template>
<div>
  <GChart id="bubble_chart"
      type="BubbleChart"
      :data="chartData"
      :options="chartOpt"
  />
  <v-data-table
      :headers="tableHeaders"
      :items="wordsData"
      :items-per-page="10"
      class="elevation-1"
  ></v-data-table>

  <div class="text-center">
    <div>
      <v-btn @click="downloadString" class="ma-2" color="green darken-2" dark><v-icon dark left>mdi-file-download-outline</v-icon>Download Data</v-btn>
    </div>
  </div>
  
</div>
</template>

<script>
// CommitChart.js
import { GChart } from 'vue-google-charts'
import { helper } from '../helper.js';

export default {
  components: {
    GChart
  },
  props: ["chartData", "chartOpt", "chartStyle"],
  methods: {
    downloadString( ){
      let header = this.tableHeaders.map( e => e.text )
      let headerStr = header.join("\t") + "\n"
      let body = this.wordsData.map( e=> [ e.ID, e.dist, e.x, e.y].join("\t") )
      let bodyStr = body.join("\n")
      console.log( "Downloading .... ")
      helper.downloadString( headerStr + bodyStr, "txt/tsv", "data.tsv" )
    }
  },
  computed: {
    tableHeaders(){
      return [
        {
            text: 'Name',
            align: 'start',
            sortable: false,
            value: 'ID',
        },
        { text: 'Freq(BubbleSize)', value: 'freq' },
        { text: 'Distance(BubbleColor)', value: 'dist' },
        { text: 'co-X', value: 'x' },
        { text: 'co-Y', value: 'y' },
        { text: 'co-r', value: 'r'  }, 
      ]
    },
    wordsData(){
      let d = []
      if(this.chartData){
        for(let e of this.chartData.slice(1)){
          d.push( {
            'ID': e[0], 
            'freq': e[5], 
            'dist': helper.float_round(e[3]), 
            'x': helper.float_round(e[1]),
            'y': helper.float_round(e[2]),
            'r': helper.float_round( e[4])
            })
        }
        helper.log( d )
        return d
      } else {
        return []
      }
    }
  }
}

// REF
// vue-chartjs : https://github.com/apertureless/vue-chartjs
</script>

<style>
#bubble_chart > div > div:nth-child(1) {
  margin: auto;
}
</style>
